import UWGuidelines from 'components/common/general/UWGuidelines';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRootStore } from 'store/rootStore';
import { WrapperStyled } from './styles';

export const ComparisonUWRules: React.FC = observer(() => {
  const { comparisonStore, domainStoreV2 } = useRootStore();
  return domainStoreV2.showQuotingUWGuidelinesFeature && comparisonStore.uwGuidelines.length > 0 ? (
    <WrapperStyled>
      <UWGuidelines uwGuidelines={comparisonStore.uwGuidelines} />
    </WrapperStyled>
  ) : null;
});
